<template>
    <div>
        <!-- Title -->
        <div class="d-flex pb-3 mb-3 border-bottom-light justify-content-between align-items-center pointer" 
             @click="toggleExpand"
             v-if="type !== 'eventPriceGroups'">
            
            <span class="font-weight-600">RULES</span>
            <i class="ico mx-0 fs-normal" :class="{'ico-arrow-top':panelExpanded, 'ico-arrow-bottom':!panelExpanded}"></i>
        </div>
        
        <h3 v-else class="pt-3 pb-4">Rules</h3>

        <!-- Shown if expanded -->
        <div class="panelHolder" :class="{closed: type === 'eventPriceGroups' ? false : !panelExpanded}">

            <!-- Got resources, lets show them -->
            <template>
                <div v-if="!hasFixedDecomposedPricesInProds">
                    <div class="form-group row">
                        <div class="col-sm-12">
                            <table class="table narrow" v-if="showTable">
                                <thead>
                                    <tr>
                                        <th class="text-center" style="width: 10%;">Order</th>
                                        <th style="width: 25%;">Rules Groups</th>
                                        <th class="pl-3" style="width: 10%;">Info</th>
                                        <th class="pl-3" style="width: 50%;">Booking Window</th>
                                        <th class="pl-3" style="width: 5%">&nbsp;</th>
                                    </tr>
                                </thead>
                                <draggable v-model="group[type]" :disabled="disabled" :v-bind="draggableOptions" @input="updateOrder()" class="w-100" :tag="'tbody'">
                                    <tr class="stopRow w-100 tr-size onHover" v-for="(group, index) in group[type]" v-if="!group.isDeleted">
                                        <td class="overflowHidden">
                                            <div class="routeMarker radius-circle">
                                                <span class="fs-smaller radius-circle">{{group.executionOrder}}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div v-tooltip="group.priceGroup ? group.priceGroup.name : null">
                                                <v-select
                                                    :options="existingGroups"
                                                    class="compact-dropdown"
                                                    label="name"
                                                    :disabled="group.isInGroup || disabled"
                                                    :value="group.priceGroup.name"
                                                    @input="updateGroupInfo(index, $event)">
                                                </v-select>
                                            </div>
                                        </td>
                                        <td class="pl-3">
                                            <i class="fa fa-info-circle largest medium pt-1 ml-2" v-tooltip="agentTooltip(group)"></i>
                                        </td>
                                        <td class="pl-3">
                                            <span>{{bwDetails(group.priceGroup)}}</span>
                                        </td>
                                        <td class="pl-3">
                                            <i class="ico-delete largest medium" :class="{'pointer':!disabled, 'notAllowed':disabled}" @click="deleteRow(group, index)"></i>
                                        </td>
                                    </tr>
                                </draggable>
                            </table>

                            <div v-if="showClickEdit" class="d-flex align-items-center justify-content-center dark font-weight-600 mt-4">
                                <i class="fa fa-info-circle fs-largest"></i>
                                <div class="fs-large">Please click <span class="darkest">'Edit'</span> to add new rule groups. </div>
                            </div>

                            <div v-if="showNoGroupsCreated" class="d-flex align-items-center justify-content-center dark font-weight-600 mt-4">
                                <i class="fa fa-info-circle fs-largest"></i>
                                <div class="fs-large">There are no <span class="darkest">Rule Groups</span> created, please create them first!</div>
                            </div>

                            <div v-if="showLoadingGroups" class="p-4 text-center">
                                <div class="fs-large mb-2">Loading Rule Groups</div>
                                <loader></loader>
                            </div>

                            <div v-if="showAddGroupBtn"
                                 class="pl-2 add d-flex align-items-center fs-small bold mt-4 mb-3">
                                 <div :class="{'pointer':!disabled, 'notAllowed':disabled}" @click="addGroup">
                                    <i class="ico-add fs-smallest add-circle color-1"></i> Add Group
                                 </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div v-else class="d-flex align-items-center justify-content-center dark font-weight-600 mt-4">
                    <i class="fa fa-info-circle fs-largest"></i>
                    <div class="fs-large">Only available if you don't have <span class="darkest">fixed decomposed pricing.</span></div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import extendedVSelect from '@/extends/vue-select'
import draggable from 'vuedraggable'
import Loader from '@/tools/loaders/loader1'

export default {
    data: function() {
        return {
            panelExpanded: false,
            draggableOptions: {
                draggable:'.stopRow',
                animation: 200,
            },
            ruleMap: {
                '1-1-3': 'Base Price | Occupation (More then) | Price Increase',
                '1-2-3': 'Base Price | Occupation (Less then) | Price Increase',
                '2-1-1': 'Sales Channels | Occupation | Open/Close',
                '2-1-3': 'Sales Channels | Occupation | Price Increase',
                '2-4-2': 'Sales Channels | Number of Seats | Closed',
                '2-3-3': 'Sales Channels | Days of Week | Price Increase',
                '3-1-3': 'Days of Week | Occupation | Price Increase',
            },
            groupsInInitGroup: []
        }
    },
    props: {
        group:{
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        readOnly: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: null
        }
    },
    created: function() {
        if (this.getRulesGroups.length === 0) {
            this.downloadRulesGroup();
        }

        this.initRulesManager();
    },
    computed: {
        ...mapGetters([
            'getRulesGroups',
            'getLoadingGroups',
            'getSelectedEvent',
            'getSelectedEventUpdateFlags'
        ]),
        showTable() {
            return !this.disabled && this.availableRulesGroups.length > 0 || this.hasGroupRulesAssociated && this.type !== 'eventPriceGroups';
        },
        showClickEdit() {
            return !(!this.disabled || this.availableRulesGroups.length === 0 || this.hasGroupRulesAssociated && this.type !== 'eventPriceGroups');
        },
        showNoGroupsCreated() {
            return this.availableRulesGroups.length === 0 && !this.getLoadingGroups && !this.hasGroupRulesAssociated;
        },
        showAddGroupBtn() {
            return !this.readOnly && this.existingGroups.length > 0 && !this.disabled;
        },
        showLoadingGroups() {
            return this.getLoadingGroups && !this.disabled;
        },
        hasGroupRulesAssociated() {
            if (!this.group.productGroupPriceGroups) return false;

            return this.group.productGroupPriceGroups.some(group => !group.isDeleted);
        },
        hasFixedDecomposedPricesInProds() {
            if (!this.group) return false;

            const prices = this.type !== 'eventPriceGroups'
                ? this.group.productGenderPrices
                : this.group.eventGenderPrices;

            if (!Array.isArray(prices)) return false;

            return prices.some(item =>
                item.componentRuleType === 0 &&
                Array.isArray(item.productGenderPriceComponents) &&
                item.productGenderPriceComponents.length > 0
            );
        },
        availableRulesGroups() {
            return this.getRulesGroups;
        },
        existingGroups() {         
            const existentGroups = this.getRulesGroups.reduce((acc, group) => {
                const belongToGroup = this.groupsInInitGroup.size > 0 && this.groupsInInitGroup.has(group.id);
                
                acc.push({
                        name: group.name,
                        executionOrder: 1,
                        isDeleted: false,
                        isInGroup: belongToGroup,
                        priceGroup: group,
                    })

                return acc;
            },[]);
            
            const usedGroups = new Set(this.group[this.type].map(group => {
                if (!group.isDeleted) {
                    return group.priceGroup.id;
                }
            }));

            return existentGroups.filter(group => !usedGroups.has(group.priceGroup.id)).sort((a,b) => {
                if (a.isInGroup && !b.isInGroup) {
                    return 1;
                } else if (!a.isInGroup && b.isInGroup) {
                    return -1;
                } else {
                    return 0;
                }     
            });
        },
    },
    methods: {
        ...mapActions([
            'downloadRulesGroup'
        ]),
        initRulesManager() {
            this.group[this.type].map(group => {
                if (group.id) {
                    group.isInGroup = true;
                }
            });

            if (this.group.backupGroup) {
                this.group.backupGroup[this.type].map(group => {
                    if (group.id) {
                        group.isInGroup = true;
                    }
                });
            }

            this.groupsInInitGroup = new Set(this.group[this.type].map(group => {
                if (group.isInGroup) {
                    return group.priceGroup.id;
                }
            }));
        },
        bwDetails(item) {
            const bookingWindowTypes = ['No Restrictions', 'Days', 'Hours', 'Event Start'];
            const bwFromType = bookingWindowTypes[item.bookingWindowFromType] || 'Invalid';
            
            const bookingWindowIndexToType = item.bookingWindowToType === 0 ? 3 : item.bookingWindowToType;
            const bwToType = bookingWindowTypes[bookingWindowIndexToType] || 'Invalid';

            const occupationTypeSymbols = {1: '>', 2: '≥', 3: '<', 4: '≤'};
            const occupationTypeSymbol = occupationTypeSymbols[item.occupancyType] || '';

            const formatTime = (time) => {
                const [hours, minutes] = time.split(':');
                return `${hours}:${minutes}`;
            };

            const bwFromVal = item.bookingWindowFromType === 2 ? formatTime(item.bookingWindowFrom) : item.bookingWindowFrom;
            const bwToVal = item.bookingWindowToType === 2 ? formatTime(item.bookingWindowTo) : item.bookingWindowTo;

            const fromText = item.bookingWindowFromType === 0 ? bwFromType : `${bwFromVal} ${bwFromType}`;
            const toText = item.bookingWindowToType === 0 ? bwToType : `${bwToVal} ${bwToType}`;

            return `${item.isBookingWindowActive ? 'ON' : 'OFF'} ${item.isBookingWindowActive ? `| ${occupationTypeSymbol} ${item.occupancy}% | From: ${fromText} - Until: ${toText}` : ''}`;
        },
        updateGroupInfo(idx, event) {
            if (this.type === "eventPriceGroups" && !this.getSelectedEventUpdateFlags.PriceGroup) {
                this.eventActivateUpdateFlag('priceGroup')
            }

            if (event.isInGroup) {
                const eventIdx = this.group[this.type].findIndex(group => group.priceGroup.id === event.priceGroup.id);
                
                this.group[this.type][eventIdx].isDeleted = false;
                this.$set(this.group[this.type], idx, this.group[this.type][eventIdx])
                this.group[this.type].splice(eventIdx, 1);
            } else {
                this.$set(this.group[this.type], idx, event)
            }

            this.updateOrder();
        },
        createTooltipContent(rules) {
            let content = 
                `<div class="border rounded p-1 my-1">
                    <h5 class="pb-0 mb-2 m-2 border-0">Rules</h5>
                        <div class="d-flex mb-1 mt-1 m-2">
                            <table class="table narrow mt-2">
                                <thead>
                                    <tr>
                                        <th style="width: 12%;" class="fs-smaller text-center">Order</th>
                                        <th style="width: 35%;" class="fs-smaller">Name</th>
                                        <th style="width: auto;" class="pl-3 fs-smaller">Variables</th>
                                    </tr>
                                </thead>
                            <tbody>`;

            rules.forEach(group => {
                content += `
                <tr class="noHover">
                    <td class="fs-smaller text-center">${group.ruleOrder}</td>
                    <td class="fs-smaller">${group.name}</td>
                    <td class="pl-3 fs-smaller">${group.variables}</td>
                </tr>
                `;
            });

            content += `
                        </tbody>
                    </table>
                </div>
            </div>    
            `;

            return content;   
        },
        agentTooltip(group) {
            const rules = group.priceGroup.priceRules.reduce((acc, rule) => {
                const key = `${rule.priceRule.targetVariableType}-${rule.priceRule.conditionType}-${rule.priceRule.actionType}`
                
                acc.push({
                    name: rule.priceRule.name,
                    variables: this.ruleMap[key],
                    ruleOrder: rule.executionOrder,
                    canceling: rule.priceRule.behaviorOnCancellation
                })

                return acc
            }, [])

            return {
                content: this.createTooltipContent(rules),
                classes: ['size'],
                show: false
            }
        },
        updateOrder() {
            if(this.disabled){
                return false
            }

            if (this.type === "eventPriceGroups" && !this.getSelectedEventUpdateFlags.PriceGroup) {
                this.eventActivateUpdateFlag('priceGroup');
            }

            this.group[this.type].map((group, index) => {
                if (!group.isDeleted) {
                    group.executionOrder = index + 1
                }
            })
        },
        deleteRow(group, idx) {
            if(this.disabled){
                return false
            }

            if (this.type === "eventPriceGroups" && !this.getSelectedEventUpdateFlags.PriceGroup) {
                this.eventActivateUpdateFlag('priceGroup');
            }

            if (!group.isInGroup) {
                this.group[this.type].splice(idx, 1);
            } else {
                group.isDeleted = true;
                group.executionOrder = this.group[this.type].length;
                this.group[this.type].splice(idx, 1);
                this.group[this.type].push(group);
            }

            this.updateOrder();
        },
        addGroup() {
            if(this.disabled){
                return false
            }

            if (this.type === "eventPriceGroups" && !this.getSelectedEventUpdateFlags.PriceGroup) {
                this.eventActivateUpdateFlag('priceGroup');
            }

            const lastValidIndex = this.group[this.type].findIndex(group => group.isDeleted);
            let alreadyAdded = null;
            
            this.group[this.type].map(group => {
                if (group.isDeleted && group.priceGroup.id === this.existingGroups[0].priceGroup.id) {
                    group.isDeleted = false;
                    alreadyAdded = true;
                    group.executionOrder = lastValidIndex + 1;
                }
            })

            if (!alreadyAdded) {
                if (lastValidIndex === -1) {
                    this.group[this.type].push(this.existingGroups[0])
                } else {
                    this.group[this.type].splice(lastValidIndex, 0, this.existingGroups[0])
                }
            }
            
            this.updateOrder();
        },
        toggleExpand() {
            if(!this.panelExpanded){
                this.$set(this, 'panelExpanded', true);
            } else {
                this.panelExpanded = !this.panelExpanded;
            }
        },
    },
    components:{
        vSelect: extendedVSelect,
        draggable,
        Loader
    }
}
</script>

<style lang="scss" scoped>
    @import '../../../../assets/scss/_variables.scss';
    
    .panelHolder {
        &.closed {
            max-height: 0;
            overflow: hidden;
        }
    }

    table {
        tr {
            th, td{
                vertical-align: middle;
            }
        }

        th {
            font-weight: 400;
        }

        tbody {
            tr:hover {
                border: none;
                transform: none;
            }

            tr.noHover:hover {
                border: none;
                background-color: white;
                transform: none;
            }
        } 
    }

    .overflowHidden {
        overflow: hidden;
    }

    tbody .stopRow {
        overflow: hidden;
        cursor: grab;

        &.sortable-ghost {
            cursor: grabbing !important;
        }
    }

    tbody .stopRow:first-child .routeMarker span::before,
    tbody .stopRow:last-child .routeMarker span::after {
        display: none;
    }

    tbody .stopRow:first-child .routeMarker span,
    tbody .stopRow:only-child:last-child .routeMarker span {
        box-shadow: 0 0 0 2pt $color-3;
    }

    tbody .stopRow:last-child .routeMarker span {
        box-shadow: 0 0 0 2pt $color-6;
    }

    .routeMarker {
        position: relative;
        display: block;
        width: 20px;
        height: 20px;
        z-index: 1;
        margin: auto;

        span {
            position: absolute;
            text-align: center;
            width: 20px;
            height: 20px;
            background-color: $lightest;
            left: 0;
            top: 0;
            padding-top: 2px;
            box-shadow: 0 0 0 2pt $dark;
        }
    }

    .tr-size {  
        height: 60px;
    }
</style>
<style lang="scss">
    .size {
        min-width: 400px;
    }

     table {
        tbody {
            tr.noHover:hover {
                border: none;
                background-color: white;
                transform: none;
            }
        } 
    }

    .compact-dropdown {
        .dropdown-toggle {
            height: 30px !important;
            width: 150px !important;

            .vs__actions {
                top: 3px !important;
            }

            .selected-tag, & input[type=search] {
                height: 28px !important;
                margin: 0 !important;
                line-height: 1.4rem !important;
                font-size: 11px !important;
            }
        }
        
        .dropdown-menu {
            font-size: 11px !important;
            
            li[role=option] a {
                padding-left: 15px !important;
            }
        }

        .open-indicator {
            height: 20px !important;
        }
    }
</style>



// WEBPACK FOOTER //
// RulesManager.vue?40fc67fa